<div class="row justify-content-center">
  <!-- Filtre de recherche -->
  <div class="width btn-filter-customer">
    <!--<ng-template [ngxPermissionsOnly]="['CUSTOMER:LIST', 'FOLDER:LIST', 'PAYMENT:CUSTOMER:LIST', 'MUTATE:LIST', 'FOLDER:TERMINATE:LIST', 'INVOICE:FOLDER:LIST']">-->
      <app-filter class="width"

        [name]="name"
        [nameTitle]="nameTitle"
        [nameType]="nameType"
        [nameClass]="nameClass"
        [nameNamespace]="nameNamespace"
        [nameGroups]="nameGroups"

        [autre]="autre"
        [autreTitle]="autreTitle"
        [autreType]="autreType"
        [autreClass]="autreClass"
        [autreNamespace]="autreNamespace"
        [autreGroups]="autreGroups"

        [bien]="bien"
        [bienTitle]="bienTitle"
        [bienType]="bienType"
        [bienClass]="bienClass"
        [bienNamespace]="bienNamespace"
        [bienGroups]="bienGroups"

        [libelle]="libelle"
        [libelleTitle]="libelleTitle"
        [libelleType]="libelleType"
        [libelleClass]="libelleClass"
        [libelleNamespace]="libelleNamespace"
        [libelleGroups]="libelleGroups"

        [user]="true"
        [userTitle]="userTitle"
        [etat]="true"
        [etatRow]="etatRow"
        [etatTitle]="etatTitle"
        [categorie]="true"
        [categorieRow]="categorieRow"
        [categorieTitle]="categorieTitle"
        [dateD]="true"
        [dateF]="true"
        [create]="true"
        [min]="true"
        [minTitle]="minTitle"
        [max]="true"
        [maxTitle]="maxTitle"
        [ordre]="true"
        [code]="true"
        [count]="true"
        [type]="true"
        [typeRow]="typeRow" (typeEvent)="onChangeLoad($event)" (filterEvent)="onFilter($event)">
      </app-filter>
    <!--</ng-template>-->
  </div>
  <!--<ng-template [ngxPermissionsExcept]="['CUSTOMER:LIST', 'FOLDER:LIST', 'PAYMENT:CUSTOMER:LIST', 'MUTATE:LIST', 'FOLDER:TERMINATE:LIST', 'INVOICE:FOLDER:LIST']">
    <div class="col-md-12">
      <app-no-droit [title]="'client'"></app-no-droit>
    </div>
  </ng-template> -->

  <!-- BOUTONS DE GESTION -->
  <div class="col-md-12 mb-4 btn-all-customer">
    <div class="first">
      <div class="second">
        <div class="btn-customer">
          <div  class="btn-group m-1" ngbDropdown ngbTooltip="Cliquez ici pour ajouter un client">
            <button class="btn btn-primary" ngbDropdownToggle type="button">
              Ajouter un client <i class="feather icon-user"></i>
            </button>
            <div ngbDropdownMenu>
              <a class="dropdown-item btn-add-entr" (click)="addCustomer('PARTICULIER')">Particulier</a>
              <a class="dropdown-item" (click)="addCustomer('ENTREPRISE')">Entreprise</a>
            </div>
          </div>
        </div>
        <div class="btn-folder">
          <div  class="btn-group m-1" ngbDropdown ngbTooltip="Cliquez ici pour ajouter un dossier">
            <button class="btn btn-secondary m-1" ngbDropdownToggle type="button">
              Dossier <i class="feather icon-folder"></i>
            </button>
            <div ngbDropdownMenu>
              <a class="dropdown-item" (click)="addFolder()">Ajouter</a>
              <a  class="dropdown-item" (click)="addMutate()">Muter</a>
              <a  class="dropdown-item" (click)="addTerminate()">Résilier</a>
            </div>
          </div>
        </div>
        <div class="btn-inventory">
          <button (click)="addInventory()" type="button" class="btn btn-info m-1"
          ngbTooltip="Cliquez ici pour ajouter un état des lieux">
            Renseigner un état des lieux <i class="feather icon-list"></i>
          </button>
        </div>
        <!-- <div class="btn-payment" data-hint="" data-hintposition="top-right"> -->
        <div class="btn-payment">
          <button (click)="addPayment()" type="button" class="btn btn-success m-1" ngbTooltip="Cliquez ici pour ajouter un paiement">
            Enregistrer un paiement <i class="feather icon-credit-card"></i>
          </button>
        </div>
        <!-- <div class="btn-payment" data-hint="" data-hintposition="top-right"> -->
        <div class="btn-payment">
          <button (click)="addInvoice()" type="button" class="btn btn-warning m-1" ngbTooltip="Cliquez ici pour ajouter une facture">
            Enregistrer une facture <i class="feather icon-credit-card"></i>
          </button>
        </div>
        <div class="btn-payment">
          <button (click)="addWalletTransaction()" type="button" class="btn btn-info m-1" ngbTooltip="Cliquez ici pour effectuer un dépôt ou retrait sur le wallet">
            Dépôt/Retrait wallet <i class="fas fa-wallet"></i>
          </button>
        </div>
      </div>
    </div>
    <div class=" float-right m-1" >
      <button (click)="onChangeView()" ngbTooltip="Cliquez ici pour changer de vue" type="button" class="btn btn-secondary m-1"
      ngbTooltip="Cliquez ici pour Definir Mes Validateurs">
      <i class="feather icon-grid" *ngIf="view"></i>
      <i class="fas fa-table" *ngIf="!view"></i>
     </button>
     <div class="btn-group float-right m-1 btn-outil-customer" ngbDropdown>
      <button class="btn btn-warning" ngbDropdownToggle type="button">
        Outils <i class="fas fa-tools"></i>
      </button>
      <div class="dropdown-menu-right" ngbDropdownMenu>
        <a  class="dropdown-item" (click)="onPrinter()" ngbTooltip="Cliquez ici pour imprimer le listing">
          Imprimer <i class="feather icon-printer"></i>
        </a>
        <a class="dropdown-item" (click)="onExport()" ngbTooltip="Cliquez ici pour exporter le listing">
          Exporter <i class="fa fa-file-excel"></i>
        </a>
        <a class="dropdown-item" [hidden]="visible" (click)="onImport()" ngbTooltip="Cliquez ici pour importer un fichier">
          Importer <i class="feather icon-download"></i>
        </a>
        <a class="dropdown-item" [hidden]="visible" (click)="onModel()" ngbTooltip="Cliquez ici pour génerer un modèle">
          Génerer <i class="feather icon-upload"></i>
        </a>
      </div>
     </div>
    </div>
  </div>

  <!-- Liste des clients -->
  <div class="width list-customer">
    <!--<ng-template ngxPermissionsOnly="CUSTOMER:LIST">-->
      <div class="col-md-12" *ngIf="type === 'CLIENT'">
        <span class="badge badge-primary mb-4 f-14 width">
          Liste des clients
        </span>
        <app-no-data class="width" [title]="'Aucun client trouvé'" *ngIf="customers && customers.length === 0"></app-no-data>
      </div>
      <div class="col-md-12" *ngIf="type === 'CLIENT' && customers && customers.length > 0">
        <div *ngIf="!view">
          <div class="row">
            <div class="col-md-6" *ngFor="let item of customers; trackBy: trackByUuid">
              <app-card [hidHeader]="true" cardClass="user-card user-card-1 mt-4" blockClass="pt-0">
                <div class="user-about-block text-center">
                  <div class="row align-items-end">
                    <div class="col text-left pb-3">
                      <span class="badge badge-{{ item?.type === 'ENTREPRISE' ? 'info': 'secondary' }}">{{item?.type}}</span>
                      <span *ngIf="item?.secteur === 'PRIVE' || item?.secteur === 'PUBLIC'" class="badge badge-{{ item?.secteur === 'PRIVE' ? 'success': 'warning' }}">{{item?.secteur === 'PRIVE' ? 'Secteur Privée' : 'Secteur Public' }}</span>
                    </div>
                    <div class="col">
                      <img loading="lazy" *ngIf="item?.type === 'PARTICULIER' && item?.sexe === 'Masculin'" class="img-radius img-fluid wid-80 hei-80" [src]="item.photoSrc ? publicUrl+'/'+item.photoSrc : 'assets/images/avatar-default.png'"  onerror="this.onerror=null; this.src='assets/images/avatar-default.png'"/>
                      <img loading="lazy" *ngIf="item?.type === 'PARTICULIER' && item?.sexe === 'Féminin'" class="img-radius img-fluid wid-80 hei-80" [src]="item.photoSrc ? publicUrl+'/'+item.photoSrc : 'assets/images/avatar-mlle.jpeg'"  onerror="this.onerror=null; this.src='assets/images/avatar-mlle.jpeg'"/>
                      <img loading="lazy" *ngIf="item?.type === 'ENTREPRISE' && item?.photoSrc" class="img-radius img-fluid wid-80 hei-80" [src]="item.photoSrc ? publicUrl+'/'+item.photoSrc : 'assets/images/avatar-default.png'"  onerror="this.onerror=null; this.src='assets/images/avatar-default.png'"/>
                      <i *ngIf="item?.type === 'ENTREPRISE' && !item?.photoSrc" class="fas fa-building fa-5x"></i>
                    </div>
                    <div class="col text-right pb-3">
                      <span class="badge badge-{{ item?.etat === 'INACTIF' ? 'danger': 'success' }}">
                        {{ item?.etat }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="text-center">
                  <a (click)="showCustomer(item)" href="javascript:">
                    <h4 class="mb-1 mt-3">{{item?.nom}}</h4>
                    <p class="mb-3 text-muted">
                      <b><i class="fas fa-qrcode"></i> {{ item?.code }}</b>
                      <b class="m-4"><i class="feather icon-phone"></i> {{item?.telephone}}</b>
                      <b class="m-4"><i class="feather icon-file-text"></i> {{ item?.nbrDossier }} Dossier(s) actif(s)</b>
                    </p>
                    <p class="mb-1 text-muted">
                      <b> {{ item?.type === 'ENTREPRISE' ? 'Siège social' : 'Domicile' }}  : </b> {{ item?.type === 'ENTREPRISE' ? item?.siegeSocial : item?.domicile }}
                      h4<b class="m-4 text-danger font-weight-bold">{{ item?.impaye < 0 ? 'A rembouser' : 'Doit' }}: {{item.impaye| number }} {{global.device}}</b>
                    </p>
                  </a>
                </div>
                <div class="text-right">
                  <button  (click)="showCustomer(item)" type="button" class="btn btn-icon btn-secondary" ngbTooltip="Détails">
                    <i class="fas fa-eye"></i>
                  </button>
                  <button  (click)="editCustomer(item)" type="button" class="btn btn-icon btn-primary ml-1" ngbTooltip="Modifier">
                    <i class="feather icon-edit-2"></i>
                  </button>
                  <button  (click)="printerCustomer(item)" type="button" class="btn btn-icon btn-warning ml-1" ngbTooltip="Imprimer">
                    <i class="feather icon-printer"></i>
                  </button>
                  <ng-template >
                    <button *ngIf="item?.isDelete" (click)="delete(item)" type="button" class="btn btn-icon btn-danger ml-1" ngbTooltip="Supprimer">
                      <i class="feather icon-trash"></i>
                    </button>
                  </ng-template>
                </div>
              </app-card>
            </div>
          </div>
        </div>
        <div *ngIf="view">
          <app-card [hidHeader]="true" cardClass="card-datatable" *ngIf="customers && customers.length > 0">
            <div class="table-responsive">
              <table datatable [dtOptions]="dtOptions" class="table table-sm table-striped table-bordered nowrap table-hover">
                <thead class="thead-light">
                  <tr>
                    <th>Client</th>
                    <th>Dossiers</th>
                    <th>Type</th>
                    <th>État</th>
                    <th>Crée le</th>
                    <th >Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of customers; trackBy: trackByUuid">
                    <td class="align-middle">
                      <img loading="lazy" *ngIf="item?.type === 'PARTICULIER' && item?.sexe === 'Masculin'" class="img-radius img-fluid wid-50 hei-50" [src]="item.photoSrc ? publicUrl+'/'+item.photoSrc : 'assets/images/avatar-default.png'"  onerror="this.onerror=null; this.src='assets/images/avatar-default.png'"/>
                      <img loading="lazy" *ngIf="item?.type === 'PARTICULIER' && item?.sexe === 'Féminin'" class="img-radius img-fluid wid-50 hei-50" [src]="item.photoSrc ? publicUrl+'/'+item.photoSrc : 'assets/images/avatar-mlle.jpeg'"  onerror="this.onerror=null; this.src='assets/images/avatar-mlle.jpeg'"/>
                      <img loading="lazy" *ngIf="item?.type === 'ENTREPRISE' && item?.photoSrc" class="img-radius img-fluid wid-50 hei-50" [src]="item.photoSrc ? publicUrl+'/'+item.photoSrc : 'assets/images/avatar-default.png'"  onerror="this.onerror=null; this.src='assets/images/avatar-default.png'"/>
                      <i *ngIf="item?.type === 'ENTREPRISE' && !item?.photoSrc" class="fas fa-building fa-5x"></i>

                      <div class="m-0  ml-1 d-inline-block align-middle font-16">
                        <span class="mb-1 mt-3">{{item?.nom}}</span>
                        <p class="mb-1 text-muted">
                          <b><i class="fas fa-qrcode"></i> {{ item?.code }}</b>
                        </p>
                        <p class="mb-1 text-muted">
                          <b class=""><i class="feather icon-phone"></i> {{item?.telephone}}</b>
                        </p>

                        <p class="mb-1 text-muted">
                          <b> {{ item?.type === 'ENTREPRISE' ? 'Siège social' : 'Domicile' }}  : </b> {{ item?.type === 'ENTREPRISE' ? item?.siegeSocial : item?.domicile }}
                          <b class="m-4 text-danger font-weight-bold">{{ item?.impaye < 0 ? 'A rembouser' : 'Doit' }}: {{item.impaye| number }} {{global.device}}</b>
                        </p>
                      </div>
                    </td>
                    <td>
                      <p class="mb-1 text-muted">
                        <b class=""> {{ item?.nbrDossier }} Dossier(s) actif(s)</b>
                      </p>
                    </td>
                    <td>
                      <div class=" text-left ">
                        <span class="badge badge-{{ item?.type === 'ENTREPRISE' ? 'info': 'secondary' }}">{{item?.type}}</span>
                        <span *ngIf="item?.secteur === 'PRIVE' || item?.secteur === 'PUBLIC'" class="badge badge-{{ item?.secteur === 'PRIVE' ? 'success': 'warning' }}">{{item?.secteur === 'PRIVE' ? 'Secteur Privée' : 'Secteur Public' }}</span>
                      </div>
                    </td>
                    <td>
                      <span class="badge badge-{{ item?.etat === 'INACTIF' ? 'danger': 'success' }}">
                        {{ item?.etat }}
                      </span>
                    </td>
                    <td class="align-middle">{{item?.createdAt| date: "d MMMM y 'à' h:mm:ss" : '' : 'fr-FR'}}</td>


                    <td class="table-action">
                      <button  (click)="showCustomer(item)" type="button" class="btn btn-icon btn-secondary" ngbTooltip="Détails">
                        <i class="fas fa-eye"></i>
                      </button>
                      <button  (click)="editCustomer(item)" type="button" class="btn btn-icon btn-primary ml-1" ngbTooltip="Modifier">
                        <i class="feather icon-edit-2"></i>
                      </button>
                      <button  (click)="printerCustomer(item)" type="button" class="btn btn-icon btn-warning ml-1" ngbTooltip="Imprimer">
                        <i class="feather icon-printer"></i>
                      </button>
                      <ng-template ngxPermissionsOnly="CUSTOMER:DELETE">
                        <button *ngIf="item?.isDelete" (click)="delete(item)" type="button" class="btn btn-icon btn-danger ml-1" ngbTooltip="Supprimer">
                          <i class="feather icon-trash"></i>
                        </button>
                      </ng-template>
                    </td>
                  </tr>
                </tbody>

              </table>
            </div>
          </app-card>


      </div>
  </div>
  <!--<ng-template ngxPermissionsExcept="CUSTOMER:LIST" [ngxPermissionsOnly]="['FOLDER:LIST', 'PAYMENTCUSTOMER:LIST', 'MUTATE:LIST', 'FOLDERTERMINATE:LIST', 'INVOICE:FOLDER:LIST']">
    <div class="col-md-12">
      <app-no-droit *ngIf="type === 'CLIENT'" [title]="'liste client'"></app-no-droit>
    </div>
  </ng-template>-->

  <!-- Liste des dossiers -->
  <!-- <ng-template ngxPermissionsOnly="FOLDER:LIST">-->
    <div class="col-md-12" *ngIf="type === 'DOSSIER'">
      <span class="badge badge-secondary mb-4 f-14 width">
        Liste des dossiers
      </span>
      <app-no-data class="width" [title]="'Aucun dossier trouvé'" *ngIf="folders && folders.length === 0"></app-no-data>
    </div>
    <app-folder-list class="width" [folders]="folders" [view]="view" *ngIf="type === 'DOSSIER' && folders && folders.length > 0"></app-folder-list>
  <!-- </ng-template>-->
  <!-- <ng-template ngxPermissionsExcept="FOLDER:LIST">
    <div class="col-md-12">
      <app-no-droit *ngIf="type === 'DOSSIER'" [title]="'liste dossier'"></app-no-droit>
    </div>
  </ng-template>-->

  <!-- Liste des factures -->
  <!-- <ng-template ngxPermissionsOnly="INVOICE:FOLDER:LIST">-->
    <div class="col-md-12" *ngIf="type === 'FACTURE' && invoices && invoices.length === 0">
      <span class="badge badge-secondary my-2 f-14 formBadge width">
        Liste des factures
      </span>
      <app-no-data [title]="'Aucune facture de dossier trouvé'" *ngIf="type === 'FACTURE' && invoices && invoices.length === 0"></app-no-data>
    </div>
    <app-invoice-customer-list class="width" [invoices]="invoices" *ngIf="type === 'FACTURE' && invoices && invoices.length > 0"></app-invoice-customer-list>
  <!-- </ng-template>-->
 <!-- <ng-template ngxPermissionsExcept="INVOICE:FOLDER:LIST"> -->
    <!-- <div class="col-md-12">
      <app-no-droit *ngIf="type === 'FACTURE'" [title]="'liste facture dossier'"></app-no-droit>
    </div> -->
  <!-- </ng-template>-->

  <!-- LISTE DES PAYEMENTS -->
 <!--  <ng-template ngxPermissionsOnly="PAYMENT:CUSTOMER:LIST"> -->
    <div class="col-md-12" *ngIf="type === 'PAIEMENT'">
      <span class="badge badge-success my-2 f-14 formBadge width">
        Liste des paiements
      </span>
      <app-no-data class="width" [title]="'Aucun paiement trouvé'" *ngIf="payments && payments.length === 0"></app-no-data>
    </div>
    <app-payment-customer-list class="width" [payments]="payments" *ngIf="type === 'PAIEMENT' && payments && payments.length > 0"></app-payment-customer-list>
  <!-- </ng-template> -->
 <!--  <ng-template ngxPermissionsExcept="PAYMENT:CUSTOMER:LIST">
    <div class="col-md-12">
      <app-no-droit *ngIf="type === 'PAIEMENT'" [title]="'liste paiement'"></app-no-droit>
    </div>
  </ng-template> -->

  <!-- Liste des mutations -->
  <!--<ng-template ngxPermissionsOnly="MUTATE:LIST"> -->
    <div class="col-md-12" *ngIf="type === 'MUTATION' && mutates && mutates.length === 0">
      <span class="badge badge-secondary my-2 f-14 formBadge width">
        Liste des mutations
      </span>
      <app-no-data [title]="'Aucune mutation de dossier trouvé'" *ngIf="type === 'MUTATION' && mutates && mutates.length === 0"></app-no-data>
    </div>
    <app-mutate-list class="width" [mutates]="mutates" *ngIf="type === 'MUTATION' && mutates && mutates.length > 0"></app-mutate-list>
  <!--</ng-template> -->
  <!--<ng-template ngxPermissionsExcept="MUTATE:LIST">
    <div class="col-md-12">
      <app-no-droit *ngIf="type === 'MUTATION'" [title]="'liste mutation'"></app-no-droit>
    </div>
  </ng-template> -->

  <!-- Liste des résiliations de dossier -->
  <!--<ng-template ngxPermissionsOnly="FOLDER:TERMINATE:LIST"> -->
    <div class="col-md-12" *ngIf="type === 'RESILIATION'">
      <span class="badge badge-secondary my-2 f-14 formBadge width">
        Liste des résiliation de dossier
      </span>
      <app-no-data [title]="'Aucune résiliation de dossier trouvée'" *ngIf="type === 'RESILIATION' && terminates && terminates.length === 0"></app-no-data>
    </div>
    <app-folder-terminate-list class="width" [terminates]="terminates" *ngIf="type === 'RESILIATION' && terminates && terminates.length > 0"></app-folder-terminate-list>
  <!--</ng-template> -->
  <!--<ng-template ngxPermissionsExcept="FOLDER:TERMINATE:LIST">
    <div class="col-md-12">
      <app-no-droit *ngIf="type === 'RESILIATION'" [title]="'liste résiliation dossier'"></app-no-droit>
    </div>
  </ng-template> -->


  
  <!-- LISTE DES ETAT DES LIEUX -->
    <div class="col-md-12" *ngIf="type === 'ETAT'">
      <span class="badge badge-info my-2 f-14 formBadge width">
        Liste des états de lieux
      </span>
      <app-no-data class="width" [title]="'Aucun etat de lieux trouvé'" *ngIf="inventories && inventories.length === 0"></app-no-data>
    </div>
    <app-inventory-customer class="width" [action]="true" [inventories]="inventories" [locataire]="locataire"
      *ngIf="type === 'ETAT' && inventories && inventories.length > 0">
    </app-inventory-customer>
</div>
